import React, { useState } from 'react';
import './Sidebar.css';

function Sidebar({ items, activeItem, onItemChange, userName, roleLabel = 'Operations', onLogout,
  companies, activeCompany, onCompanyChange, companyName, brandTitle }) {
  const [collapsed, setCollapsed] = useState(false);

  // Support both flat items array and grouped sections array
  const isGrouped = items.length > 0 && items[0].section !== undefined;
  // One global company context (set once here, used across every screen). A super-admin gets a switcher;
  // a tenant user just sees their own company name.
  const showSwitcher = Array.isArray(companies) && companies.length > 0 && onCompanyChange;

  return (
    <>
      <button className="sidebar-mobile-toggle" onClick={() => setCollapsed(!collapsed)}>
        <span className="sidebar-toggle-bar" />
        <span className="sidebar-toggle-bar" />
        <span className="sidebar-toggle-bar" />
      </button>

      <aside className={`sidebar ${collapsed ? 'collapsed' : ''}`}>
        <div className="sidebar-header">
          {brandTitle && (
            <div className="sidebar-brand" style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
              <span style={{ width: 24, height: 24, borderRadius: 7, display: 'flex', alignItems: 'center',
                justifyContent: 'center', color: '#fff', fontWeight: 900, fontSize: 13,
                background: 'linear-gradient(135deg,#6366f1,#8b5cf6)' }}>M</span>
              <span style={{ fontWeight: 700, fontSize: 14 }}>{brandTitle}</span>
            </div>
          )}
          <span className="sidebar-role-badge">{roleLabel}</span>
        </div>
        {(showSwitcher || companyName) && (
          <div className="sidebar-company">
            <span className="sidebar-company-label">Company</span>
            {showSwitcher ? (
              <select className="sidebar-company-select" value={activeCompany || ''} onChange={(e) => onCompanyChange(e.target.value)}>
                {companies.map((c) => <option key={c.id} value={c.id}>{c.name || c.id}</option>)}
              </select>
            ) : (
              <span className="sidebar-company-name">{companyName}</span>
            )}
          </div>
        )}

        <nav className="sidebar-nav">
          {isGrouped ? (
            items.map((group, gi) => (
              <div key={gi} className="sidebar-section">
                {group.section && <div className="sidebar-section-label">{group.section}</div>}
                {group.items.map((item) => (
                  <button
                    key={item.id}
                    className={`sidebar-item ${activeItem === item.id ? 'active' : ''}`}
                    onClick={() => { onItemChange(item.id); setCollapsed(true); }}
                  >
                    <span className="sidebar-item-icon">{item.icon}</span>
                    <span className="sidebar-item-label">{item.label}</span>
                    {item.badge ? <span className="sidebar-item-badge">{item.badge}</span> : null}
                  </button>
                ))}
              </div>
            ))
          ) : (
            items.map((item) => (
              <button
                key={item.id}
                className={`sidebar-item ${activeItem === item.id ? 'active' : ''}`}
                onClick={() => { onItemChange(item.id); setCollapsed(true); }}
              >
                <span className="sidebar-item-icon">{item.icon}</span>
                <span className="sidebar-item-label">{item.label}</span>
                {item.badge ? <span className="sidebar-item-badge">{item.badge}</span> : null}
              </button>
            ))
          )}
        </nav>

        <div className="sidebar-footer">
          {userName && <span className="sidebar-username">{userName}</span>}
          <button className="sidebar-logout" onClick={onLogout}>Sign Out</button>
        </div>
      </aside>

      {!collapsed && <div className="sidebar-overlay" onClick={() => setCollapsed(true)} />}
    </>
  );
}

export default Sidebar;
